import styled, {css} from 'styled-components';

import {ms} from '@yourcoach/shared/styles/normalizeSize';
import {getColor} from '@yourcoach/shared/styles/utils';
import {Text} from '@yourcoach/shared/uikit/Text';
import {View} from '@yourcoach/shared/uikit/View';

export const Container = styled(View)<{coach?: boolean}>`
  align-items: center;
  justify-content: center;
  width: ${ms(28)};
  height: ${ms(28)};
  border-radius: ${ms(4)};
  background-color: ${getColor('icon5')};
  box-shadow: 0 10px 20px ${getColor('shadow2')};
  ${p =>
    p.coach &&
    css`
      background-color: ${getColor('icon4')};
      box-shadow: 0 10px 20px ${getColor('shadow1')};
    `}
`;

export const Label = styled(Text)`
  font-weight: ${p => p.theme.fontWeight.semibold};
  font-size: 0.75rem;
  line-height: ${ms(20)};
  color: ${getColor('text2')};
`;
